import React from 'react';
import PermissionAllowed from 'ui-component/permissions/PermissionAllowed';
import { CloseIcon, DeleteIcon } from 'ui-component/custom-icons/icons';
import StatusBadge from 'ui-component/StatusBadge';
import { getCurrencySymbol } from 'utils/currency';

// ✅ Clear
const ProductDetailModalMobile = ({ openPopup, details, handleClose, handleDeleteRepair }) => {
    if (!openPopup) return null;

    return (
        <div
            className="d-flex"
            style={{
                width: '100vw',
                height: '100dvh',
                position: 'fixed',
                left: 0,
                top: 0,
                zIndex: 20,
                background: 'rgba(0,0,0,0.07)',
                justifyContent: 'center',
                alignItems: 'end',
                paddingBottom: '90px',
                backdropFilter: 'blur(8px)',
                WebkitBackdropFilter: 'blur(8px)'
            }}
        >
            <div
                className="popup product-popup-mobile d-md-none"
                style={{
                    position: 'relative',
                    transform: 'none',
                    top: 0,
                    left: 0,
                    maxWidth: '90%',
                    background: '#fff',
                    borderRadius: 12,
                    boxShadow: 'rgb(0 0 0 / 37%) 0px 0px 20px',
                    width: '100%',
                    minHeight: '60dvh',
                    padding: '24px 16px 0 16px',
                    display: 'flex',
                    flexDirection: 'column'
                }}
            >
                {/* Header */}
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 12, position: 'relative' }}>
                    <div style={{ flex: 1, textAlign: 'center' }}>
                        <svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="80px" height="80px" x="0" y="0" viewBox="0 0 24 24" style={{ enableBackground: 'new 0 0 512 512' }} ><g><g data-name="Layer 2"><circle cx="12" cy="12" r="10.75" fill="#0066ff" opacity="1" data-original="#4294ff"></circle><g fill="#eef3ff"><circle cx="12" cy="7.5" r="1.5" fill="#eef3ff" opacity="1" data-original="#eef3ff"></circle><rect width="3" height="8" x="10.5" y="10.5" rx="1" fill="#eef3ff" opacity="1" data-original="#eef3ff"></rect></g></g></g></svg>
                        <div style={{ fontSize: '24px', fontWeight: 600, marginTop: 8 }}>Item Information</div>
                    </div>
                    <button className="btn modal-close-icon" onClick={handleClose} style={{ position: 'absolute', right: 10, top: 10 }}>
                        <CloseIcon height={'18px'} width={'18px'} />
                    </button>
                </div>

                <div style={{ flex: 1, overflowY: 'auto', paddingBottom: 16 }}>
                    <div style={{ marginBottom: 12 }}>
                        <div style={{ display: 'flex', marginBottom: 8 }}>
                            <div style={{ flex: 1, color: '#888', fontWeight: 500 }}>IMEI</div>
                            <div style={{ flex: 2 }}>{details?.imei}</div>
                        </div>
                        <div style={{ display: 'flex', marginBottom: 8 }}>
                            <div style={{ flex: 1, color: '#888', fontWeight: 500 }}>Product</div>
                            <div style={{ flex: 2 }}>{details?.productName}</div>
                        </div>
                        <div style={{ display: 'flex', marginBottom: 8 }}>
                            <div style={{ flex: 1, color: '#888', fontWeight: 500 }}>Color</div>
                            <div style={{ flex: 2 }}>{details?.colorName}</div>
                        </div>
                        <div style={{ display: 'flex', marginBottom: 8 }}>
                            <div style={{ flex: 1, color: '#888', fontWeight: 500 }}>Status</div>
                            <div style={{ flex: 2 }}>
                                <StatusBadge itemStatus={details?.status} />
                            </div>
                        </div>
                        {details?.oldGradeName && (
                            <div style={{ display: 'flex', marginBottom: 8 }}>
                                <div style={{ flex: 1, color: '#888', fontWeight: 500 }}>Grade</div>
                                <div style={{ flex: 2 }}>{details?.oldGradeName}</div>
                            </div>
                        )}
                        {details?.hasComment && (
                            <div style={{ display: 'flex', marginBottom: 8 }}>
                                <div style={{ flex: 1, color: '#888', fontWeight: 500 }}>Comment</div>
                                <div style={{ flex: 2 }}>
                                    <div dangerouslySetInnerHTML={{ __html: details?.comment }} />
                                </div>
                            </div>
                        )}
                    </div>
                    {details?.repairs?.length > 0 && (
                        <div style={{ marginTop: 18 }}>
                            <div style={{ fontSize: '15px', fontWeight: 600, marginBottom: 8 }}>Repairs</div>
                            <div>
                                {details?.repairs?.map((repair, index) => (
                                    <div
                                        key={index}
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            borderBottom: '1px solid #eee',
                                            padding: '10px 0'
                                        }}
                                    >
                                        <div style={{ flex: 2 }}>
                                            <div style={{ fontWeight: 500 }}>{repair?.repair_type?.name}</div>
                                            <div style={{ fontSize: 13, color: '#888' }}>
                                                {repair?.assigned_to?.name}
                                            </div>
                                        </div>
                                        <div style={{ flex: 1, fontSize: 13 }}>
                                            {getCurrencySymbol(repair?.currency)}{' '}
                                            {parseFloat(repair?.cost).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}
                                        </div>
                                        <div style={{ flex: 1 }}>
                                            <StatusBadge itemStatus={repair?.status} />
                                        </div>
                                        <PermissionAllowed permissions={['Delete Operations Repairs']}>
                                            <div style={{ flexShrink: 0, marginLeft: 8 }}>
                                                <div
                                                    className="btn btn-danger btn-outlined-danger white-var btn-sm cursor-pointer"
                                                    onClick={() => handleDeleteRepair(index, repair, details)}
                                                >
                                                    <div style={{ margin: 'auto 3px' }}>
                                                        <DeleteIcon height="14px" width="14px" />
                                                    </div>
                                                </div>
                                            </div>
                                        </PermissionAllowed>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ProductDetailModalMobile;
